export const safeDocument = typeof document !== "undefined" ? document : {};
export const safeWindow = typeof window === "undefined" ? {} : window;
export const safeNavigator = typeof navigator === "undefined" ? {} : navigator;
